import './ScopeBadge.css';

/**
 * Bölge sorumlusunun kapsamını başlığın yanında gösterir (ör. "Çankaya · Kızılay +2").
 *
 * Sahipte hiç çizilmez — filonun tamamını gördüğü için kapsam rozetinin bir anlamı yok,
 * bu kararı çağıran (Header) accessCtx.isOwner'a bakarak verir.
 */
const ScopeBadge = ({ areas }) => {
    const names = (areas || []).map(a => a.displayName).filter(Boolean);
    if (names.length === 0) return null;

    const visible = names.slice(0, 2);
    const extra = names.length - visible.length;

    return (
        <span className="scope-badge" title={names.join(', ')}>
            {visible.join(', ')}
            {extra > 0 && ` +${extra}`}
        </span>
    );
};

export default ScopeBadge;
